export default function (csrfToken) {
    return {
        user: null,
        canApprove: null,
        users: null,
        permissions: null,
        announcements: null,
        objectives: null,
        terms: null,
        currentTerm: null,
        selectedTerms: null,
        levels: null,
        attendance: null,
        ranks: null,
        events: null,
        attendanceTypes: null,
        eventTypes: null,

        inventory: null,
        inventoryTypes: null,

        positions: null,
        units: null,

        selfUpdates: null,
        approvalUpdates: null,
        publishedUpdates: null,

        selfDisputes: null,
        disputeTypes: null,
        disputeEvents: null,

        distributionList: null,
        files: [
            {
                'title': 'Operations Order',
                'name': 'ops-order'
            },
            {
                'title': 'Organization Chart',
                'name': 'org-chart'
            }],
        csrfToken: csrfToken
    }
}
